import 'react-app-polyfill/stable';
import React from 'react';
import App from './App';
import * as serviceWorker from './serviceWorker';


import ReactDOM from 'react-dom';
import { loadConfig, loadZipData } from './constants/api.config';
import axios from 'axios';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import "./fonts.css"

// 🔁 Old Config loader
const oldLoadConfig = async () => {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
    if (!response.ok) {
      throw new Error('Failed to load configuration file');
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading config.json:', error);
  }
};



window.RenderApp = async () => {


  const configFile = await oldLoadConfig();
  loadConfig(configFile);
  // await loadZipData("JobSchedulerApp.zip");
  // await loadZipData(configFile.DATAPOOL_RESOURCE);


  ReactDOM.render(

    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
    ,
    document.getElementById('root')
  );
};

window.RenderApp();

// serviceWorker.unregister();
